export default {
  namespaced: true,
  state: {
    tableList: [],
    configs: {
      item1: {
        label: '序号',
        width: '60',
        isShow: true
      },
      item2: {
        label: '报销人',
        width: '120',
        isShow: true
      },
      item3: {
        label: '发生时间',
        width: '180',
        isShow: true
      },
      item4: {
        label: '费用类别',
        width: '200',
        isShow: true
      },
      item4_1: {
        label: '业务号',
        width: '150',
        isShow: true
      },
      item5: {
        label: '费用内容摘要',
        width: '180',
        isShow: true
      },
      tagType: {
        label: '报销金额（元）',
        width: '180',
        isShow: true
      },
      states: {
        label: '状态',
        width: '120',
        isShow: false
      },
      paymentMethod: {
        label: '付款方式',
        width: '120',
        isShow: false
      },
      item8: {
        label: '凭证类型',
        width: '120',
        isShow: false
      },
      tradingMethods: {
        label: '交易方式',
        width: '120',
        isShow: false
      },
      item11: {
        label: '发生事由',
        width: '300',
        isShow: true
      },
      item12: {
        label: '成本中心',
        width: '180',
        isShow: true
      },
      item13: {
        label: '分摊比例',
        width: '100',
        isShow: true
      },
      item14: {
        label: '分摊金额（元）',
        width: '180',
        isShow: true
      },
      item16: {
        label: '所属部门',
        width: '180',
        isShow: false
      },
      item16_1: {
        label: '钉钉部门',
        width: '180',
        isShow: false
      },
      item17: {
        label: '添加日期',
        width: '120',
        isShow: false
      }
    }
  }
}